import { useState } from "react";

const BACKEND_URL = window.location.hostname === 'localhost' 
  ? process.env.REACT_APP_BACKEND_URL 
  : window.location.origin;

export const Navbar = ({ isDark, toggleTheme, scrollToSection }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleTutorLogin = () => {
    window.location.href = `${BACKEND_URL}/api/login/`;
  };

  const handleSignup = () => {
    window.location.href = `${BACKEND_URL}/api/signup/`;
  };

  const handleScrollToSection = (id) => {
    scrollToSection(id);
    setMobileMenuOpen(false);
  };

  return (
    <nav className="navbar" data-testid="navbar">
      <div className="navbar-container">
        <a href="/" className="navbar-brand">
          <div className="brand-mark">T</div>
          <div className="brand-text">
            <span className="brand-title">Tutrlink</span>
            <span className="brand-sub">Education Platform</span>
          </div>
        </a>

        {/* Desktop Navigation */}
        <div className="navbar-links">
          <button onClick={() => handleScrollToSection('features')} className="nav-link">Features</button>
          <button onClick={() => handleScrollToSection('pricing')} className="nav-link">Pricing</button>
          <button onClick={() => handleScrollToSection('how-it-works')} className="nav-link">How It Works</button>
        </div>

        <div className="navbar-actions">
          <button className="theme-toggle-nav" onClick={toggleTheme} aria-label="Toggle theme">
            <i className={`fa-solid ${isDark ? 'fa-sun' : 'fa-moon'}`}></i>
          </button>
          <button className="btn btn-ghost" onClick={handleTutorLogin} data-testid="nav-login-btn">
            Log In
          </button>
          <button className="btn btn-primary" onClick={handleSignup} data-testid="nav-signup-btn">
            Get Started Free
          </button>
        </div>

        {/* Mobile Menu Button */}
        <button 
          className="mobile-menu-btn" 
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <i className={`fa-solid ${mobileMenuOpen ? 'fa-xmark' : 'fa-bars'}`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="mobile-menu">
          <button onClick={() => handleScrollToSection('features')} className="mobile-nav-link">Features</button>
          <button onClick={() => handleScrollToSection('pricing')} className="mobile-nav-link">Pricing</button>
          <button onClick={() => handleScrollToSection('how-it-works')} className="mobile-nav-link">How It Works</button>
          <hr className="mobile-divider" />
          <button className="btn btn-ghost btn-block" onClick={handleTutorLogin}>Log In</button>
          <button className="btn btn-primary btn-block" onClick={handleSignup}>Get Started Free</button>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
